<cb-dialog dialogHeading="Contract Pricing Details">
    <form class="flex-col flex" #contractPricingForm="ngForm">
        @if (data.clientSale.isThirdPartyHouseAndLand) {
            <cb-currency
                type="number"
                label="Lot Deposit"
                [required]="true"
                [inclGst]="true"
                name="thirdPartyLotDeposit"
                [decimals]="0"
                [(ngModel)]="contractPricingUpdateDto.thirdPartyLotDeposit"
            >
            </cb-currency>
        }
        @if (data.clientSale.isThirdPartyHouseAndLand) {
            <cb-currency
                type="number"
                label="Lot Purchase Price"
                [required]="true"
                [inclGst]="true"
                name="thirdPartyLotPurchasePrice"
                [decimals]="0"
                [(ngModel)]="contractPricingUpdateDto.thirdPartyLotPurchasePrice"
            >
            </cb-currency>
        }
        @if (data.clientSale.isExternalDesignAndLand) {
            <cb-currency
                type="number"
                label="Lot Deposit"
                [required]="true"
                [inclGst]="true"
                name="designAndLandLotDeposit"
                [decimals]="0"
                [(ngModel)]="contractPricingUpdateDto.designAndLandLotDeposit"
            >
            </cb-currency>
        }
        @if (data.clientSale.isExternalDesignAndLand) {
            <cb-currency
                type="number"
                label="Lot Purchase Price"
                [required]="true"
                [inclGst]="true"
                name="designAndLandLotPurchasePrice"
                [decimals]="0"
                [(ngModel)]="contractPricingUpdateDto.designAndLandLotPurchasePrice"
            >
            </cb-currency>
        }
        @if (data.clientSale.isThirdPartyHouseAndLand || data.clientSale.isExternalDesignAndLand) {
            <div class="start-center flex-row">
                <cb-client-account-autocomplete-scroller
                    class="cb-margin-right flex"
                    label="Lot Vendor"
                    name="lotVendorSearch"
                    [(ngModel)]="selectedLotVendor"
                    [requireMatch]="true"
                    [matchProps]="['id']"
                    [required]="true"
                >
                </cb-client-account-autocomplete-scroller>
                <button
                    mat-icon-button
                    matTooltip="Add a new Account"
                    (click)="openAddDialog(contractPricingForm)"
                >
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        }
        <cb-currency
            label="Contract Price"
            [required]="true"
            name="contractPrice"
            [inclGst]="true"
            [decimals]="0"
            (change)="TriggerContractPriceUpdate()"
            [(ngModel)]="contractPricingUpdateDto.contractPrice"
        >
        </cb-currency>
        @if (
            data.clientSale.isHouseAndLand ||
            (data.clientSale.isDesignAndLand && !data.clientSale.lot.hasExternalLandVendor)
        ) {
            <cb-currency
                class="cb-margin-top"
                label="Contract Generation Fee"
                [required]="true"
                [inclGst]="true"
                name="contractGenerationFee"
                [decimals]="0"
                [(ngModel)]="contractPricingUpdateDto.contractGenerationFee"
            >
            </cb-currency>
        }
        @if (
            data.clientSale.isHouseAndLand ||
            (data.clientSale.isDesignAndLand && !data.clientSale.lot.hasExternalLandVendor)
        ) {
            <cb-currency
                label="Lot Holding Deposit"
                [required]="true"
                [inclGst]="true"
                name="lotHoldingDeposit"
                [decimals]="0"
                [(ngModel)]="contractPricingUpdateDto.lotHoldingDeposit"
            >
            </cb-currency>
        }
        <cb-user-autocomplete-scroller
            class="cb-margin-top flex"
            label="Contract Manager"
            name="contractManagerSearch"
            [(ngModel)]="selectedContractManager"
            [requireMatch]="true"
            [matchProps]="['id']"
            [active]="true"
            [tag]="CONTRACT_MANAGER_TAG"
            [required]="true"
        >
        </cb-user-autocomplete-scroller>
        <cb-select
            [required]="true"
            label="Payment Template"
            name="paymentTemplates"
            [valueProp]="WHOLE_OPTION_VALUE_PROP"
            [(ngModel)]="selectedPaymentTemplate"
            (change)="onPaymentTemplateChanged($event)"
            [options]="paymentTemplates"
        >
        </cb-select>
        <cb-progress-payments-table [contractPricingUpdateDto]="contractPricingUpdateDto">
        </cb-progress-payments-table>
        @if (data.clientSale.isDesignAndBuild) {
            <cb-select
                [required]="true"
                class="cb-margin-top-3x"
                label="Balance Payable on"
                name="balancePayableOn"
                [(ngModel)]="contractPricingUpdateDto.clientSaleBalanceDueTrigger"
                [options]="CLIENT_SALE_BALANCE_DUE_TRIGGER_ENUM.toLookup()"
            >
            </cb-select>
        }
    </form>
    <div actions>
        <button mat-raised-button
                color="primary"
                [disabled]="contractPricingForm.invalid || contractPricingForm.pristine"
                [clickLimit]="1"
                (cbClick)="save()">
            Save
        </button>
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
</cb-dialog>
